var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclesOnlyMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 160,
    viewBox: "0 0 361 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1600_481)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 160,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.187,
    cy: 140.292,
    r: 139.976,
    stroke: "url(#paint0_angular_1600_481)",
    strokeOpacity: 0.3,
    strokeWidth: 0.632209
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.187,
    cy: 140.292,
    r: 100.837,
    stroke: "url(#paint1_angular_1600_481)",
    strokeOpacity: 0.3,
    strokeWidth: 0.632209
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.186,
    cy: 140.292,
    r: 62.9048,
    stroke: "url(#paint2_angular_1600_481)",
    strokeOpacity: 0.3,
    strokeWidth: 0.632209
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.186,
    cy: 140.292,
    r: 29.8696,
    stroke: "url(#paint3_angular_1600_481)",
    strokeOpacity: 0.3,
    strokeWidth: 0.632209
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_1600_481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.187 140.292) rotate(90) scale(140.292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03F59",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004876",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_1600_481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.187 140.292) rotate(90) scale(101.153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03F59",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004876",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_1600_481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.186 140.292) rotate(90) scale(63.2209)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03F59",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004876",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_1600_481",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.186 140.292) rotate(90) scale(30.1857)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03F59",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004876",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1600_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesOnlyMobile);
export default __webpack_public_path__ + "static/media/circles_only_mobile.60a7fd7996d2bcf5e2d9652e39eadfa9.svg";
export { ForwardRef as ReactComponent };